import styled from 'styled-components';

export const HeaderDivider = styled.div`
    border-top: .5px solid #83BED3;
    padding-bottom: 10px;    
`;


// WEBPACK FOOTER //
// ./src/common/components/HeaderDivider.js